import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { getAllSearchNewsByCategoryData, getAllSearchNewsData } from '../../Services/AllAPIs';
import '../../styles/search-news/main.css';
import LoadingSpinner from '../LoadingSpinner';

const SearchNews = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [loader, setLoader] = useState(true);
    const [news, setNews] = useState([]);
    const [categories, setCategories] = useState([]);
    const [totalPages, setTotalPages] = useState(1);
    const [error, setError] = useState(null);

    // Form data for filtering
    const [formData, setFormData] = useState({
        title: searchParams.get('title') || '',
        category: searchParams.get('category') || '',
        month: searchParams.get('month') || '',
        year: searchParams.get('year') || '',
    });

    const [currentPage, setCurrentPage] = useState(Number(searchParams.get('page')) || 1);

    // Fetch data based on search parameters (filters)
    const getAllNews = async (filters = {}) => {
        setLoader(true);
        try {
            const response = await getAllSearchNewsData(filters);
            const notification = response.data.news;
            const categories = Object.values(response.data.categories);
            setCategories(categories);
            setNews(notification);
            setTotalPages(response.data.totalPages);
            setLoader(false);
        } catch (error) {
            console.error(error);
            setError('An error occurred while fetching the news.');
            setLoader(false);
        }
    };

    // Fetch news by category when a category is selected
    const getAllSearchNewsByCategory = async (id) => {
        if (id) {
            setLoader(true);
            try {
                const response = await getAllSearchNewsByCategoryData(id);
                const news = Object.values(response.data.news);
                console.log('cattt--->>>>', news)
                setNews(news);
                setTotalPages(response.data.totalPages);
                setLoader(false);
            } catch (error) {
                console.error(error);
                setError('An error occurred while fetching the news by category.');
                setLoader(false);
            }
        }
    };

    // Fetch news data whenever page, filters or category change
    useEffect(() => {
        const filters = { ...formData, page: currentPage };
        if (formData.category) {
            getAllSearchNewsByCategory(formData.category);
        } else {
            getAllNews(filters);
        }
        setSearchParams(filters, { replace: true });
    }, [formData, currentPage, setSearchParams]);

    // Handle input changes
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        // Encoding category name to ensure it doesn't break the URL structure
        if (name === "category") {
            setFormData((prevData) => ({ ...prevData, [name]: encodeURIComponent(value) }));
        } else {
            setFormData((prevData) => ({ ...prevData, [name]: value }));
        }
    };

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();
        setCurrentPage(1);
        setSearchParams({ ...formData, page: 1 });
    };

    // Handle pagination
    const handlePagination = (direction) => {
        if (direction === 'next' && currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        } else if (direction === 'previous' && currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    // Format date for display
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const options = { day: '2-digit', month: 'short', year: 'numeric' };
        return date.toLocaleDateString('en-GB', options);
    };

    if (loader) {
        return <LoadingSpinner />
    }

    if (error) {
        return <div>{error}</div>;
    }

    return (
        <div id="searchNewsMain">
            <section className="news-main-div">
                <div className="container">
                    <div>
                        <h1 className="my-heading">
                            {formData.category ? `${decodeURIComponent(formData.category)} News & Updates` : 'News & Updates'}
                        </h1>

                    </div>
                    <div className="row p-0 m-0 d-flex align-items-start justify-content-between">
                        <div className="col-lg-3">
                            <form onSubmit={handleSubmit} method="GET">
                                <div>
                                    <label>Title</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        name="title"
                                        placeholder="Enter Search Value"
                                        value={formData.title}
                                        onChange={handleInputChange}
                                    />
                                </div>
                                <div className="mt-2">
                                    <label>Category</label>
                                    <select
                                        name="category"
                                        id="category"
                                        className="form-control"
                                        value={formData.category}
                                        onChange={handleInputChange}
                                    >
                                        <option value="">--Select Category--</option>
                                        {categories.length > 0 ? (
                                            categories.map((category) => (
                                                <option key={category.id} value={category.name}>
                                                    {category.name}
                                                </option>
                                            ))
                                        ) : (
                                            <option value="">No categories available</option>
                                        )}
                                    </select>
                                </div>
                                <div className="mt-2">
                                    <label>Month</label>
                                    <select
                                        name="month"
                                        id="month"
                                        className="form-control"
                                        value={formData.month}
                                        onChange={handleInputChange}
                                    >
                                        <option value="">--Select Month--</option>
                                        {[...Array(12).keys()].map((monthIndex) => (
                                            <option key={monthIndex + 1} value={monthIndex + 1}>
                                                {new Date(0, monthIndex).toLocaleString('default', { month: 'short' })}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="mt-2">
                                    <label>Year</label>
                                    <select
                                        name="year"
                                        id="year"
                                        className="form-control"
                                        value={formData.year}
                                        onChange={handleInputChange}
                                    >
                                        <option value="">--Select Year--</option>
                                        {[2025, 2024, 2023, 2022, 2021, 2020].map((year) => (
                                            <option key={year} value={year}>
                                                {year}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="btns-grp mt-2">
                                    <button type="submit">Search</button>
                                    <button
                                        type="reset"
                                        onClick={() => {
                                            setFormData({ title: '', category: '', month: '', year: '' });
                                            setSearchParams({}); // Reset search parameters
                                        }}
                                    >
                                        Reset
                                    </button>
                                </div>
                            </form>
                        </div>
                        <div className="col-lg-8 table-div">
                            <div>
                                <table>
                                    <thead>
                                        <tr>
                                            <th style={{ borderRight: '1px solid #FFF', textAlign: 'center' }}>Date</th>
                                            <th style={{ borderRight: '1px solid #FFF' }}>Title</th>
                                            <th className="text-center">View</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {news.length > 0 ? (
                                            news.map((item) => (
                                                <tr key={item.id}>
                                                    <td className="date-data">{formatDate(item.created_at)}</td>
                                                    <td>
                                                        <a href={item.url} target="_blank" rel="noopener noreferrer">
                                                            {item.title}
                                                        </a>
                                                    </td>
                                                    <td>
                                                        <button>
                                                            <a href={item.url} target="_blank" rel="noopener noreferrer">
                                                                View
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="3" className="text-center">
                                                    No results found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                <br />
                                {/* Pagination */}
                                <div className="pagination">
                                    <button
                                        className="btn btn-primary"
                                        onClick={() => handlePagination('previous')}
                                        style={{ backgroundColor: '#14297a' }}
                                    >
                                        Previous
                                    </button>
                                    <button
                                        className="btn btn-primary"
                                        onClick={() => handlePagination('next')}
                                        style={{ backgroundColor: '#14297a', marginLeft: 10 }}
                                    >
                                        Next
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default SearchNews;
